<frg-side-menu-container>
    <frg-side-menu class="background-side-menu">
    </frg-side-menu>
    <div class="content" frg-menu-content>
        <div class="header">
            <frg-header [title]="title" [delegations]="profilDelegationList" [delegationName]="delegationName" [accountName]="accountName" [isBack]="isBack" [backPage]="backPage"
                [backCallBack]="backCallBack">
            </frg-header>
        </div>

        <router-outlet></router-outlet>
    </div>
</frg-side-menu-container>
